import React from 'react';
import Status from 'Components/DesignSystem/Status/Status';

/**
 * "Recommended" (§ 146). A fixed-size `tw-w-[103px] tw-h-[22px]` box on
 * `tw-bg-emerald-500` — a stock Tailwind ramp, not a design-system colour, and a width
 * hardcoded to the exact pixel length of the one word inside it.
 *
 * Reachable only through `DisplayBox showChip`, whose sole caller is commented out.
 */
const ChipIndicator = () => {
    return <Status tone="success" label="Recommended" data-testid="ab-recommended-chip" />;
}

export default ChipIndicator;
